export const noticeSx = { mb: 3 };

export const fillColumnSx = { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' } as const;
